// removed by extract-text-webpack-plugin
module.exports = {"fade":"fade","ModalSlider":"ModalSlider","PopUpModal":"PopUpModal","modal":"modal","show":"show","slick-arrow":"slick-arrow","slick-next":"slick-next","slick-prev":"slick-prev","Blur":"Blur","ModalDialog":"ModalDialog","modal-content":"modal-content","ModalBody":"ModalBody","slick-dots":"slick-dots","slick-active":"slick-active","slick-slider":"slick-slider","sample":"sample","slick-initialized":"slick-initialized","Content":"Content","Title":"Title","MoreBtn":"MoreBtn","HidePopupText":"HidePopupText","Swiper":"Swiper","Navigation":"Navigation","Active":"Active","CloseButton":"CloseButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ModalSlider/styles.scss
// module id = 1979
// module chunks = 10